import { render, staticRenderFns } from "./orderCgApprove.vue?vue&type=template&id=679ade4f&scoped=true"
import script from "./orderCgApprove.vue?vue&type=script&lang=js"
export * from "./orderCgApprove.vue?vue&type=script&lang=js"
import style0 from "./orderCgApprove.vue?vue&type=style&index=0&id=679ade4f&prod&scoped=true&lang=css"
import style1 from "./orderCgApprove.vue?vue&type=style&index=1&id=679ade4f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679ade4f",
  null
  
)

export default component.exports